import axios from 'axios'
import showToast from '../utils';
const httpConfig = {
  baseURL: process.env.REACT_APP_PROJECTS_API
};
// const httpConfig = {
//   baseURL: "https://skygenic-backend-dot-pl-new.uc.r.appspot.com/"
// };

console.log(httpConfig)
const httpClient = axios.create(httpConfig)
httpClient.interceptors.response.use(
  (res) => {
    return res;
  },
  (error) => {
    const expectedError =
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500;

    if (!expectedError) {
      showToast("Something went wrong, Please try again later", "error");
    } else {
      if (error.response.status === 403) {
        if (error.response.data && error.response.data.message) {
          showToast(error.response.data.message, "error");
        }
      }
      if (error.response.status === 400) {
        if (error.response.data && error.response.data.message) {
          showToast(error.response.data.message, "error");
        }
      }
      if (error.response.status === 404) {
        if (error.response.data && error.response.data.message) {
          showToast(error.response.data.message, "error");
        }
      }
    }

    return Promise.reject(error);
  }
);

export default httpClient;
